import { Box, HStack, Progress, Stack, Text } from "@chakra-ui/react"
import { UI } from "components"
import useBlackBNF from "hooks/useBlackBNF"

export default function BlackBNF(){

    const black = useBlackBNF()

    if(black.isLoading) return <UI.Box loading />
    if(!black.data?.label) return <Unset />
    if(!!black.data?.label) return <Granted />

    return(<Unset />
    )
}

const Granted = () => {

    const black = useBlackBNF()

    return(
    <UI.Box colorPalette="orange">
        <HStack gap={4} alignItems="center" h="100%">
            <UI.Lottie animation="black-bnf" style={{ width: '100px', transform: 'scale(1.8)' }} options={{ loop: false }} />
            <Box>
                <Text fontWeight="bold" fontSize="lg" color="orange.focusRing">{black.data?.label}</Text>
                <Text fontSize="sm" color="orange.fg">Você faz parte da seleta lista dos black's.</Text>
            </Box>
        </HStack>
    </UI.Box>
    )
}

const Unset = () => {

    const black = useBlackBNF()

    return(
    <UI.Box>
        <Text fontWeight="bold" fontSize="lg">Black BNF</Text>
        <Text fontSize="sm" color="GrayText">Realize mais compras para chegar ao selo BNF 200.</Text>
        <Progress.Root maxW="240px" striped animated mt={2} colorPalette="orange" value={black.data?.percentage}>
            <Progress.Track>
                <Progress.Range />
            </Progress.Track>
        </Progress.Root>
    </UI.Box>
    )
}